import { theme } from "@/services/getSiteTheme"

import { API_URL_CATALOG, API_URL_STORE } from "./urls"

// GET requests

const searchProduct = (query, page) => {
  const params = {
    productFullNameSearchMask: query,
    pageNum: page,
  }
  if (theme === "kids") {
    params.categoryCode = "STUDENTS_PRODUCT"
  }

  return window.axios
    .get(API_URL_CATALOG + "products/page/v2/get", {
      params,
    })

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const productListData = data.createdEntity

        return productListData
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })
}

const getProductAmountsByPriceIdsApi = (ids) =>
  window.axios

    .get(API_URL_STORE + "list/rests/by/product/prices/v1/get", {
      params: {
        pricesListId: ids,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity.serviceGroupList
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getBestsellersApi = () => {
  const params = {}
  params.limit = 25
  if (theme === "kids") {
    params.categoryCode = "STUDENTS_PRODUCT"
  }

  return window.axios

    .get(API_URL_STORE + "product/price/rand/v1/get", {
      params,
    })

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const products = data.createdEntity.productPrices.map((product) => ({
          ...product,
          image: product.productImage,
        }))

        return products
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })
}

const getTutorialsApi = () => {
  const params = {}
  params.limit = 25
  params.isTutorial = true
  params.categoryCode = "STUDENTS_PRODUCT"

  return window.axios
    .get(API_URL_STORE + "product/price/rand/v1/get", {
      params,
    })
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const products = data.createdEntity.productPrices.map((product) => ({
          ...product,
          image: product.productImage,
        }))
        return products
      }
      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })
}

const getProductApi = (sku) =>
  window.axios

    .get(API_URL_CATALOG + "product/page/v3/get", {
      params: {
        sku,
      },
    })

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const product = data.createdEntity

        return product
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getProductOffersApi = async (sku) =>
  window.axios

    .get(API_URL_STORE + "product/price/list/actual/v1/get", {
      params: {
        sku,
      },
    })

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const productOffers = data.createdEntity.productPrices

        return productOffers
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getProductsListApi = (params) =>
  window.axios

    .get(API_URL_CATALOG + "products-by-attrs/list/v1/get", {
      params,
    })

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const productListData = {
          items: data.createdEntity.productsCount,
          itemsOnPage: data.createdEntity.elements,
          pages: data.createdEntity.pages,
          list: data.createdEntity.products,
          breadcrumbs: data.createdEntity.breadcrumb,
        }

        return productListData
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getVendorProductsListApi = (params) =>
  window.axios

    .get(API_URL_CATALOG + "products-by-attrs-vendor/list/v1/get", {
      params,
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        const productListData = {
          items: data.responseEntity.productsCount,
          itemsOnPage: data.responseEntity.elements,
          pages: data.responseEntity.pages,
          list: data.responseEntity.products,
        }

        return productListData
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getVendorProductsFiltersApi = (vendorLogin) =>
  window.axios

    .get(API_URL_CATALOG + "products/filters/by/vendor/v1/get", {
      params: {
        vendorLogin,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return {
          manufacturerList: data.responseEntity.manufactureList,
          categoryList: data.responseEntity.categoryList,
        }
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getStoreInfoApi = (vendorLogin) =>
  window.axios

    .get(API_URL_STORE + "vendor/v2/get", {
      params: {
        vendorLogin,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const getVendorInfoApi = (vendorLogin) =>
  window.axios

    .get(API_URL_STORE + "vendor/info/v1/get", {
      params: {
        vendorLogin,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

export {
  searchProduct,
  getBestsellersApi,
  getTutorialsApi,
  getProductApi,
  getProductOffersApi,
  getProductsListApi,
  getVendorProductsListApi,
  getVendorProductsFiltersApi,
  getStoreInfoApi,
  getProductAmountsByPriceIdsApi,
  getVendorInfoApi,
}
